"use strict";
import BtnBase from './btnbase';
import Browser from './../util/browser';

class BtnClose extends BtnBase{
	constructor($con){
		super($con);
	}
	
	init(){
		this.$con.empty();
		let h = '';
		h += '<span class="l1"></span>';
		h += '<span class="l2"></span>';
		this.$con.append(h);
		
		this.$con.find('.l1').velocity('stop')
			.velocity({rotateZ:'45deg'},{duration:1});
		this.$con.find('.l2').velocity('stop')
			.velocity({rotateZ:'135deg'},{duration:1});
	}
	
	open(delay){
		this.$con.velocity('stop').css({visibility:'hidden'});
		this.$con.velocity('stop')
			.velocity({opacity:[1,0]},{duration:300,easing:'swing',visibility:'visible',delay:delay});
	}
	
	over(){
		if(Browser.isiPad) return;
		super.over();
		
		let time = 200;
		let ease = 'easeInOutCirc';
		
		this.$con.find('.l1').velocity('stop')
			.velocity({rotateZ:'135deg'},{duration:time,easing:ease});
		this.$con.find('.l2').velocity('stop')
			.velocity({rotateZ:'45deg'},{duration:time,easing:ease});		
	}
	
	out(){
		if(Browser.isiPad) return;
		
		let time = 200;
		let ease = 'easeInOutCirc';
		
		this.$con.find('.l1').velocity('stop')
			.velocity({rotateZ:'45deg'},{duration:time,easing:ease});
		this.$con.find('.l2').velocity('stop')
			.velocity({rotateZ:'135deg'},{duration:time,easing:ease});
	}

}

export default BtnClose;


// WEBPACK FOOTER //
// ./js/btn/btnclose.js